<template>
    <div>

        <div v-if="showTable" class="table-responsive-sm">
            <table class="table table-bordered table-sm table-striped">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Date</th>
                        <th>Comment</th>
                        <th>Creator</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in filteredJournal" v-bind:key="row[4]">
                        <td>{{row['type']}}</td>
                        <td>{{reformatDate(row['date_of'])}}</td>
                        <td>{{row['comment']}}</td>
                        <td>{{getUserFromId(row['creator'])}}</td>
                    </tr>
                    </tbody>
                <caption>Project Journal</caption>

            </table>
        </div>
        <div v-else>
            <small class="text-muted float-right">No Project Journal Data</small>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ProjectJournal",
        props: ['job_num'],
        methods: {
            getUserFromId(id) {
                let arr = this.$store.getters.team_list;
                let user = arr.find((user) => {
                    return user.pk === id
                });
                return user.first_name + ' ' + user.last_name
            },
            reformatDate(date) {
                let date_array = date.split('-');
                let year = date_array[0];
                let month = date_array[1];
                let day = date_array[2];
                return month + '/' + day + '/' + year.slice(-2);
            },
        },
        computed: {
            filteredJournal() {
                let entries = this.$store.getters.journal;

                if(this.job_num === undefined) {
                    return entries
                } else {
                    return entries.filter((entry) => {
                        return (entry.job === this.job_num)
                    })
                }


            },
            showTable() {
                return this.filteredJournal.length !== 0;
            },
            columns() {
                if (this.filteredJournal.length === 0) {
                    return []
                }
                return Object.keys(this.filteredJournal[0])
            },


        },
        beforeMount() {
            if(this.$store.getters.journal.length === 0) {

                this.$store.dispatch('tryRefresh', {action: 'obtainJournal', data: null}).catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e)
                })
            }
        }
    }
</script>

<style scoped>

</style>